var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTori(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2818,
    height: 2750,
    viewBox: "0 0 2818 2750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1189.36 2048.64C1183.19 2043.19 1179.32 2035.59 1178.55 2027.4L1117.21 1374.83H1335.51V2105.91C1335.51 2133.79 1302.61 2148.63 1281.71 2130.18L1189.36 2048.64ZM1335.51 1361.88V1270.78L1105.56 1250.91L1115.99 1361.88H1335.51ZM1335.51 1257.78L1104.33 1237.81L1068.2 853.403C1066.41 834.411 1081.35 818 1100.43 818H1303.14C1321.02 818 1335.51 832.494 1335.51 850.373V1257.78Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1762.18 1361.87H1928.59C1937.53 1361.87 1944.78 1354.63 1944.78 1345.69V1250.23C1944.78 1240.66 1936.53 1233.19 1927.02 1234.12L1772.49 1249.2L1762.18 1361.87ZM1759.37 1250.49L1529.1 1272.97V1361.87H1749.18L1759.37 1250.49ZM1516.15 1274.24V1361.87H903.003C894.063 1361.87 886.816 1354.63 886.816 1345.69V1250.01C886.816 1240.53 894.933 1233.08 904.382 1233.88L1449.32 1280.49C1450.3 1280.58 1451.29 1280.57 1452.27 1280.47L1516.15 1274.24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1584.53 2127.98C1564.2 2148.59 1529.11 2134.19 1529.11 2105.24V1100.95H1773.36L1688.39 2012.27C1687.7 2019.71 1684.45 2026.68 1679.21 2032L1584.53 2127.98ZM1774.57 1088H1529.11V948.421L1789.1 932.202L1774.57 1088ZM1529.11 850.378V935.446L1790.32 919.151L1796.45 853.384C1798.22 834.4 1783.28 818.005 1764.21 818.005H1561.48C1543.6 818.005 1529.11 832.499 1529.11 850.378Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.51 1088V948.827L1075.84 936.048L1090.05 1088H1335.51ZM1348.46 1088H2003.05C2010.2 1088 2016 1082.2 2016 1075.05V931.19C2016 923.715 2009.69 917.792 2002.23 918.266L1440.08 953.974L1348.46 949.465V1088ZM1061.71 935.353L1077.22 1088H814.949C807.798 1088 802 1082.2 802 1075.05V936.174C802 928.772 808.193 922.876 815.586 923.24L1061.71 935.353Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_6817_96890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1190.91 2040.86C1184.77 2035.44 1180.94 2027.9 1180.17 2019.75L1119.22 1371.31H1336.14V2097.77C1336.14 2125.47 1303.45 2140.22 1282.68 2121.88L1190.91 2040.86Z",
    fill: "url(#paint0_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.14 1358.44V1267.92L1107.64 1248.18L1118.01 1358.44H1336.14Z",
    fill: "url(#paint1_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.14 1255L1106.42 1235.15L1070.51 853.179C1068.74 834.307 1083.59 818 1102.54 818H1303.97C1321.74 818 1336.14 832.402 1336.14 850.169V1255Z",
    fill: "url(#paint2_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.11 1358.44H1925.47C1934.35 1358.44 1941.55 1351.23 1941.55 1342.35V1247.49C1941.55 1237.99 1933.36 1230.56 1923.91 1231.48L1770.36 1246.48L1760.11 1358.44Z",
    fill: "url(#paint3_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.32 1247.75L1528.51 1270.09V1358.44H1747.19L1757.32 1247.75Z",
    fill: "url(#paint4_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.64 1271.35V1358.44H906.366C897.483 1358.44 890.282 1351.23 890.282 1342.35V1247.28C890.282 1237.86 898.347 1230.45 907.737 1231.25L1449.22 1277.57C1450.2 1277.65 1451.18 1277.64 1452.16 1277.55L1515.64 1271.35Z",
    fill: "url(#paint5_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.58 2119.7C1563.38 2140.17 1528.51 2125.87 1528.51 2097.1V1099.16H1771.22L1686.79 2004.72C1686.1 2012.11 1682.87 2019.04 1677.66 2024.32L1583.58 2119.7Z",
    fill: "url(#paint6_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.42 1086.29H1528.51V947.596L1786.86 931.479L1772.42 1086.29Z",
    fill: "url(#paint7_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.51 850.173V934.703L1788.07 918.511L1794.16 853.16C1795.92 834.296 1781.08 818.005 1762.13 818.005H1560.68C1542.91 818.005 1528.51 832.407 1528.51 850.173Z",
    fill: "url(#paint8_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.14 1086.29V948L1078.11 935.301L1092.23 1086.29H1336.14Z",
    fill: "url(#paint9_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.01 1086.29H1999.46C2006.56 1086.29 2012.32 1080.53 2012.32 1073.42V930.474C2012.32 923.046 2006.05 917.161 1998.64 917.632L1440.04 953.113L1349.01 948.633V1086.29Z",
    fill: "url(#paint10_linear_6817_96890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.07 934.61L1079.48 1086.29H818.867C811.761 1086.29 806 1080.53 806 1073.42V935.426C806 928.071 812.154 922.213 819.5 922.574L1064.07 934.61Z",
    fill: "url(#paint11_linear_6817_96890)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_6817_96890",
    x: 803.427,
    y: 818,
    width: 1215.33,
    height: 1318.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.57349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28675
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6817_96890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6817_96890",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.21686,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_6817_96890"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.8675,
    dy: 12.8675
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.60843
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6817_96890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6817_96890",
    x1: 806,
    y1: 1474,
    x2: 2012.32,
    y2: 1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTori);
export default __webpack_public_path__ + "static/media/tori.59125bebe5601add8f3b1f566f837852.svg";
export { ForwardRef as ReactComponent };